import * as React from 'react';
import {View, StyleSheet, Platform} from 'react-native';
import {LoginLayout} from '../login/components/layout';
import {Button} from '../../shared/components/button';
import {Text} from '../../shared/components/text';
import {OrDelimiter} from '../../shared/components/orDelimiter';
import {images} from '../../assets/icons';
import {useStyles} from '../../shared/hooks/styles';
import {DeviceSize} from '../../shared/theme/helpers';
import {useIsSmallScreenDevice} from '../../shared/hooks/useIsSmallScreenDevice';

export interface Props {
  onEsiaClick: (e?: any) => void;
  onContinue: (e?: any) => void;
  submitting?: boolean;
}

export default (props: Props) => {
  const {onEsiaClick, onContinue, submitting} = props;
  const isSmallScreen = useIsSmallScreenDevice();

  const styles = useStyles(({mediaOnly, theme: themeFromHook}) => ({
    layoutContainer: mediaOnly(
      DeviceSize.desktop,
      {},
      Platform.OS === 'web' ? {width: '100%', alignSelf: 'stretch'} : {},
    ),
    content: StyleSheet.flatten([
      {
        width: '100%',
        alignItems: 'center',
      },
      mediaOnly(
        DeviceSize.desktop,
        {width: 300, marginTop: 16},
        {width: Platform.OS === 'web' ? '100%' : 284, maxWidth: 284, paddingTop: 8},
      ),
    ]),
    description: {
      ...themeFromHook.helpText,
      textAlign: 'center',
      marginTop: 8,
      marginBottom: isSmallScreen ? 24 : 40,
      ...mediaOnly(DeviceSize.desktop, {marginHorizontal: 0}, {marginHorizontal: 10}),
    },
    buttonWrapper: {
      width: '100%',
    },
    button: StyleSheet.flatten([
      {
        alignSelf: 'center',
        marginBottom: 0,
      },
      mediaOnly(DeviceSize.desktop, {width: 300}, {width: '100%'}),
    ]),
  }));

  return (
    <LoginLayout title='Перевыпуск карты' showHelpText={false} fitContent containerStyle={styles.layoutContainer}>
      <View style={styles.content}>
        <Text testID='card-reissue-description' style={styles.description}>
          Для продолжения выберите один из способов подтверждения данных
        </Text>
        <View style={styles.buttonWrapper}>
          <Button
            id='login-width-esia'
            type='secondary'
            style={styles.button}
            onPress={onEsiaClick}
            iconProps={{width: 20, height: 21}}
            icon={images.Esia}
            iconPosition='left'
            text='Войти через ЕСИА'
            disabled={submitting}
          />
          <OrDelimiter marginBottom={isSmallScreen ? 20 : undefined} marginTop={isSmallScreen ? 20 : undefined} />
          <Button
            id='card-reissue-continue'
            type='secondary'
            style={styles.button}
            onPress={onContinue}
            iconProps={{width: 16, height: 19}}
            icon={images.Right}
            text='Продолжить оформление'
            disabled={submitting}
          />
        </View>
      </View>
    </LoginLayout>
  );
};
